import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    const fetchLatestBlogs = async () => {
      try {
        const response = await fetch('/api/blogs/list');
        const result = await response.json();

        if (response.ok && result.success) {
          setFeaturedBlogs(result.data);
        } else {
          setError(result.message || 'Failed to load latest updates.');
        }
      } catch (err) {
        console.error('Home Grid Sync Failure:', err);
        setError('Could not connect to the content server.');
      } finally {
        setLoading(false);
      }
    };

    fetchLatestBlogs();
  }, []);

  const filteredBlogs = featuredBlogs
    .filter(blog => {
      const matchesCategory = activeCategory === 'All' || blog.tag === activeCategory;
      const matchesSearch = 
        blog.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (blog.tag && blog.tag.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesCategory && matchesSearch;
    })
    .slice(0, 6);

  const getHolographicTagStyles = (tag) => {
    const cleanTag = tag?.toLowerCase() || '';
    if (cleanTag.includes('tech') || cleanTag.includes('code') || cleanTag.includes('dev')) {
      return 'text-cyan-400 bg-cyan-950/30 border-cyan-500/20 shadow-[0_0_12px_rgba(34,211,238,0.05)]';
    }
    if (cleanTag.includes('market') || cleanTag.includes('trend') || cleanTag.includes('business')) {
      return 'text-emerald-400 bg-emerald-950/30 border-emerald-500/20 shadow-[0_0_12px_rgba(52,211,153,0.05)]';
    }
    if (cleanTag.includes('life') || cleanTag.includes('culture') || cleanTag.includes('health')) {
      return 'text-fuchsia-400 bg-fuchsia-950/30 border-fuchsia-500/20 shadow-[0_0_12px_rgba(232,121,249,0.05)]';
    }
    return 'text-amber-400 bg-amber-950/30 border-amber-500/20 shadow-[0_0_12px_rgba(251,191,36,0.05)]';
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 6000);
    }
  };

  return (
    <div className="bg-[#030712] text-slate-100 min-h-screen font-sans antialiased selection:bg-cyan-500 selection:text-slate-950 relative overflow-x-hidden">
    	<div className="relative z-50 w-full bg-white">
  <div className="absolute inset-0 bg-white"></div>

  <div className="relative py-3 border-y border-gray-200">
    <div className="max-w-7xl mx-auto flex justify-center">
      <a
        href="https://adsxpediapvtltd11086878.o18.link/c?o=21999142&m=22344&a=703490&aff_click_id={replace_it}&sub_aff_id={replace_it}"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/uploads/Car-Renewal-M.png"
          alt="ACKO Car Insurance"
          className="block"
        />
      </a>
    </div>
  </div>
</div> 
 
      {/* ================= EXTRA FEATURE: LIVE SYSTEMS RUNNER ================= */}
      <div className="w-full bg-[#0b0f19] border-b border-slate-900 py-3 overflow-hidden relative z-50 text-[10px] font-mono tracking-widest text-slate-500 uppercase">
        <div className="flex whitespace-nowrap animate-[marquee_30s_linear_infinite] gap-16">
          <div className="flex gap-16 shrink-0">
            <span>⚡ MOREVIEW NETWORK: ONLINE</span>
            <span className="text-cyan-400">● LATEST ARTICLES: UPDATED LIVE</span>
            <span>● PLATFORM STATUS: SECURE</span>
            <span className="text-fuchsia-400">● COMMUNITY SIZE: 12,500+ READERS</span>
            <span>● SERVER GLOBAL LATENCY: &lt;4ms</span>
            <span className="text-emerald-400">● ACCESS: OPEN TO PUBLIC</span>
          </div>
          <div className="flex gap-16 shrink-0" aria-hidden="true">
            <span>⚡ MOREVIEW NETWORK: ONLINE</span>
            <span className="text-cyan-400">● LATEST ARTICLES: UPDATED LIVE</span>
            <span>● PLATFORM STATUS: SECURE</span>
            <span className="text-fuchsia-400">● COMMUNITY SIZE: 12,500+ READERS</span>
            <span>● SERVER GLOBAL LATENCY: &lt;4ms</span>
            <span className="text-emerald-400">● ACCESS: OPEN TO PUBLIC</span>
          </div>
        </div>
      </div>

      {/* ================= ADVANCED BACKGROUND METALLIC FILTERS ================= */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none z-0 opacity-70" />

      {/* Glowing Vector Nodes */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[400px] bg-[radial-gradient(circle_at_top,rgba(6,182,212,0.12),rgba(217,70,239,0.03),transparent_60%)] pointer-events-none z-0" />
      <div className="absolute top-[20%] right-[-10%] w-[500px] h-[500px] bg-cyan-500/[0.02] rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="absolute top-[35%] left-[-10%] w-[500px] h-[500px] bg-fuchsia-500/[0.02] rounded-full blur-[120px] pointer-events-none z-0" />

      {/* ================= 1. THE HERO WORKSPACE (SPACING OPTIMIZED) ================= */}
      <section id="subscribe" className="relative pt-16 pb-12 lg:pt-20 lg:pb-16 z-10 mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 text-center">
        
        {/* Futuristic Floating Pill Badge */}
        

        {/* Mega Dramatic Gradient Header */}
        <h1 className="mx-auto max-w-5xl text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.1] text-white">
          Deep Dives Into Modern Tech, <br className="hidden sm:block" />
          <span className="bg-gradient-to-r from-cyan-400 via-fuchsia-400 to-amber-300 bg-clip-text text-transparent drop-shadow-[0_2px_30px_rgba(6,182,212,0.1)]">
            Trends & Digital Culture
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-slate-400 text-sm sm:text-base lg:text-lg font-normal leading-relaxed tracking-wide">
          We break down complex development tools, market movements, and daily tech life into clear, beautifully structured articles tailored for curious minds.
        </p>

        {/* High-Converting Glassmorphism Submission Hub */}
        <div className="mt-8 max-w-md mx-auto relative group">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500/30 via-fuchsia-500/30 to-amber-400/30 rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-700" />
          <form onSubmit={handleSubscribe} className="relative flex p-1.5 bg-slate-950/80 backdrop-blur-2xl rounded-xl border border-slate-800/60 transition-colors focus-within:border-cyan-500/40">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address..."
              className="bg-transparent text-xs sm:text-sm text-white placeholder-slate-600 px-4 py-3 focus:outline-none flex-grow w-full font-mono"
            />
            <button
              type="submit"
              className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-slate-950 font-bold text-xs uppercase tracking-wider px-5 py-3 rounded-lg shadow-lg active:scale-[0.98] transition-all whitespace-nowrap shrink-0"
            >
              Join Newsletter ⚡
            </button>
          </form>
        </div>

        {/* Subscription feedback banner */}
        {subscribed && (
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-950/30 border border-emerald-500/20 font-mono text-[11px] text-emerald-400 uppercase tracking-wider animate-fadeIn">
            🚀 Welcome aboard! You've joined the MoreView mailing list.
          </div>
        )}

        <p className="text-[10px] font-mono text-slate-500 mt-4 uppercase tracking-widest">Trusted by 12,500+ Readers Globally</p>
      </section>

      {/* ================= 2. INTERACTIVE CLUSTER CONTROLS (SEARCH & FILTER) ================= */}
      <section className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-10">
        <div className="flex flex-col xl:flex-row items-start xl:items-center justify-between border-b border-slate-900 pb-6 gap-6">
          <div>
            <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-cyan-400">Explore Feed</span>
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight mt-0.5">Latest Stories & Logs</h2>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full xl:w-auto">
            {/* Live Search Engine Input Node */}
            <div className="relative flex-grow sm:w-64">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search articles or tags..."
                className="w-full bg-[#0b0f19] border border-slate-800/80 rounded-xl px-4 py-2.5 text-xs font-mono text-cyan-400 placeholder-slate-600 focus:outline-none focus:border-cyan-500/40 transition-colors"
              />
              <span className="absolute right-3 top-3 text-[9px] font-mono text-slate-600">FIND</span>
            </div>

            {/* Quick-Filter Navigation Array */}
            <div className="flex flex-wrap gap-1 bg-slate-950 p-1 rounded-xl border border-slate-900 backdrop-blur-md overflow-x-auto">
              {['All', 'Tech Stack', 'Market Updates', 'Life Style'].map((category) => (
                <button
                  key={category}
                  type="button"
                  onClick={() => setActiveCategory(category)}
                  className={`text-[11px] font-medium px-3.5 py-2 rounded-lg transition-all duration-200 whitespace-nowrap ${
                    activeCategory === category
                      ? 'bg-slate-900 text-cyan-400 border border-slate-800 shadow-sm font-semibold'
                      : 'text-slate-400 hover:text-slate-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* ================= 3. PRODUCTION DATA CARD GRID ================= */}
        <div className="mt-12">
          {loading && (
            <div className="text-center py-24 text-xs font-mono text-slate-500 animate-pulse tracking-widest uppercase">
              🔄 Loading updates from the cluster...
            </div>
          )}

          {error && (
            <div className="text-center py-8 text-xs font-mono text-rose-400 bg-rose-950/10 border border-rose-900/30 max-w-md mx-auto p-4 rounded-xl backdrop-blur-xl">
              💥 Error Loading Content: {error}
            </div>
          )}

          {!loading && !error && (
            filteredBlogs.length === 0 ? (
              <div className="text-center py-20 text-slate-500 bg-slate-900/10 border border-dashed border-slate-900 rounded-2xl font-mono text-xs uppercase tracking-wider">
                No articles discovered for category "{activeCategory}".
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {filteredBlogs.map((blog) => (
                  <Link
                    key={blog.id}
                    to={`/blog/${blog.slug}`}
                    className="group bg-[#0b0f19]/40 hover:bg-[#0b0f19]/80 border border-slate-900 hover:border-slate-800/80 rounded-xl overflow-hidden transition-all duration-300 flex flex-col justify-between shadow-xl relative"
                  >
                    <div className="absolute top-0 inset-x-0 h-[1px] bg-gradient-to-r from-transparent via-cyan-500/0 to-transparent group-hover:via-cyan-400/40 transition-all duration-500"/>

                    <div className="flex flex-col">
                      <div className="w-full aspect-[16/10] overflow-hidden bg-slate-950 relative border-b border-slate-950">
                        {blog.top_image ? (
                          <img
                            src={blog.top_image}
                            alt=""
                            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500 filter brightness-[0.8] group-hover:brightness-95"
                            loading="lazy"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-[9px] font-mono text-slate-700 tracking-widest uppercase bg-slate-900/20">
                            NO IMAGE ATTACHED
                          </div>
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 via-transparent to-transparent" />
                      </div>

                      <div className="p-6">
                        <span className={`text-[9px] font-mono font-bold tracking-wider uppercase px-2 py-0.5 rounded border ${getHolographicTagStyles(blog.tag)}`}>
                          {blog.tag || 'Insight'}
                        </span>
                        <h3 className="text-lg font-bold text-slate-100 mt-3.5 group-hover:text-cyan-400 transition-colors leading-snug line-clamp-2 tracking-tight">
                          {blog.title}
                        </h3>
                      </div>
                    </div>

                    <div className="px-6 pb-6">
                      <div className="pt-4 border-t border-slate-900/60 flex items-center justify-between text-xs font-medium text-slate-500">
                        <span className="font-mono text-[10px] text-slate-500">
                          {new Date(blog.created_at).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })}
                        </span>
                        <span className="text-cyan-500 group-hover:text-cyan-400 transition-colors flex items-center gap-1 font-mono font-bold text-[10px] uppercase tracking-wider">
                          Read Article <span className="transform group-hover:translate-x-0.5 transition-transform">→</span>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )
          )}
        </div>
      </section>

      {/* ================= 4. COMPREHENSIVE NETWORK STATISTICS / SYSTEM MONITORS ================= */}
      <section className="relative z-10 py-20 border-t border-slate-900 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          <div className="bg-[#0b0f19]/20 border border-slate-900/80 p-6 rounded-xl backdrop-blur-md hover:border-cyan-500/10 transition-all duration-300">
            <div className="text-lg mb-3 text-cyan-400">📡</div>
            <h4 className="font-bold text-slate-200 text-sm tracking-tight">No-Fluff Content</h4>
            <p className="text-slate-500 text-[11px] mt-2 leading-relaxed font-mono uppercase tracking-wide">
              We skip surface-level listicles. Our articles are deep, analytical, and optimized to save you time while delivering genuine knowledge.
            </p>
          </div>
          <div className="bg-[#0b0f19]/20 border border-slate-900/80 p-6 rounded-xl backdrop-blur-md hover:border-fuchsia-500/10 transition-all duration-300">
            <div className="text-lg mb-3 text-fuchsia-400">⚡</div>
            <h4 className="font-bold text-slate-200 text-sm tracking-tight">Fast & Lightweight</h4>
            <p className="text-slate-500 text-[11px] mt-2 leading-relaxed font-mono uppercase tracking-wide">
              Our platform architecture is built to serve content lightning-fast, giving you a smooth, instant reading experience across all devices.
            </p>
          </div>
          <div className="bg-[#0b0f19]/20 border border-slate-900/80 p-6 rounded-xl backdrop-blur-md hover:border-amber-500/10 transition-all duration-300">
            <div className="text-lg mb-3 text-amber-400">🔒</div>
            <h4 className="font-bold text-slate-200 text-sm tracking-tight">Permanent Public Archives</h4>
            <p className="text-slate-500 text-[11px] mt-2 leading-relaxed font-mono uppercase tracking-wide">
              Every single article remains permanently available on our network. Reference historical insights, source code, or trends at any moment.
            </p>
          </div>
        </div>
      </section>

      {/* ================= 5. SYSTEM CLOSING RETENTION LOOP ================= */}
      <section className="relative z-10 py-28 bg-gradient-to-b from-[#0b0f19]/30 to-transparent border-t border-slate-900 text-center">
        <div className="max-w-xl mx-auto px-6">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">Never Miss a Broadcast</h2>
          <p className="mt-3.5 text-slate-400 text-xs sm:text-sm leading-relaxed max-w-md mx-auto">
            Stay ahead of the curve. Join our priority mailing stream to get clean updates, curated toolsets, and trends sent straight to your inbox.
          </p>
          <div className="mt-8">
            <a href="#subscribe" className="inline-block rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-slate-950 font-bold text-xs uppercase tracking-widest px-8 py-3.5 shadow-xl shadow-cyan-500/5 active:scale-[0.98] transition-all">
              Subscribe to Stream
            </a>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes marquee {
          0% { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-50%, 0, 0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .overflow-x-auto::-webkit-scrollbar {
          display: none;
        }
        .overflow-x-auto {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default Home;
